<template>
<div class="listing__preview">
    <div class="main__section">
      <a href="#" @click.prevent="goBack" class="button__carouselleft"></a>
        <div class="detailedstep">
            <h1>Subscriptions</h1>
            <div class="subscription__title">
                <p class="subscription__subheading">Monthly/Yearly</p>
                <checkbox></checkbox>
            </div>
            <div class="subscription__list">
                <div class="subscription__option">
                    <div class="subscription__header">
                        <h2>
                            Free
                        </h2>
                    </div>
                    <div class="subscription__main">
                        <div class="subscription__wrapper">
                            <div class="subscription__circle">

                            </div>
                            <img src="/images/freeplan.png" alt="Free plan image" class="subscription__image">
                        </div>
                        <p class="subscription__paragraph">Free listing</p>
                        <p class="subscription__paragraph">Single category listing</p>
                        <p class="subscription__paragraph subscription__paragraph--through">NO Backlink (Great for SEO)</p>
                    </div>
                    <div class="subscription__footer">
                            <p class="subscription__price">FREE</p>
                            <button class="button__payment">Use free</button>
                    </div>
                </div>
                <div class="subscription__option">
                    <div class="subscription__header subscription__header--pro">
                        <h2>
                            Pro
                        </h2>
                    </div>
                    <div class="subscription__main subscription__main--pro">
                        <div class="subscription__wrapper">
                            <div class="subscription__circle subscription__circle--pro">

                            </div>
                            <img src="/images/proplan.png" alt="Free plan image" class="subscription__image">
                        </div>
                        <p class="subscription__heading">Authority Back Link to your website, great for SEO</p>
                        <p class="subscription__paragraph">Custom company page</p>
                        <p class="subscription__paragraph">Get listed above Free listings</p>
                        <p class="subscription__paragraph ">Links to all your Social Media</p>
                        <p class="subscription__paragraph ">Upload photos of your products or Services</p>
                    </div>
                    <div class="subscription__footer">
                            <p v-if="getSubscriptionStatus" class="subscription__price">{{getSubscriptionPro}}$ / year</p>
                            <p v-else class="subscription__price">{{getSubscriptionPro}}$ / month</p>
                            <button class="button__payment button__payment--pro">Order now</button>
                    </div>
                </div>
                <div class="subscription__option">
                    <div class="subscription__header subscription__header--premium">
                        <h2>
                            Premium
                        </h2>
                    </div>
                    <div class="subscription__main subscription__main--premium">
                        <div class="subscription__wrapper">
                            <div class="subscription__circle subscription__circle--premium">

                            </div>
                            <img src="/images/premiumplan.png" alt="Free plan image" class="subscription__image">
                        </div>
                        <p class="subscription__heading">A DIRECT link to your website, great for SEO and RANKING</p>
                        <p class="subscription__paragraph">Custom company page</p>
                        <p class="subscription__paragraph">Your company will be listed above the Pro and Free listings</p>
                        <p class="subscription__paragraph">Guaranteed to be on page 1 in all your categories</p>
                        <p class="subscription__paragraph">Links to all your Social Media</p>
                        <p class="subscription__paragraph">Upload photos of your products or Services</p>
                    </div>
                    <div class="subscription__footer">
                            <p v-if="getSubscriptionStatus" class="subscription__price">{{getSubscriptionPremium}}$ / year</p>
                            <p v-else class="subscription__price">{{getSubscriptionPremium}}$ / month</p>
                            <button class="button__payment button__payment--premium">Order now</button>
                    </div>
                </div>
            </div>
        
        </div>
  </div>
    <multiple-testimonial></multiple-testimonial>
</div>
  
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import MultipleTestimonial from '../testimonials/MultipleTestimonial';
import Checkbox from '../checkbox/Checkbox';

export default {
components:{
    'multiple-testimonial':MultipleTestimonial,
    'checkbox':Checkbox
},
methods:{
    ...mapActions([
        'changeStep'
    ]),
    goBack(){
        this.changeStep(6);
    }
},
computed:{
    ...mapGetters([
        'getSubscriptionStatus',
        'getSubscriptionPro',
        'getSubscriptionPremium'
    ]),
}
}
</script>

<style>

</style>